import { createSlice } from "@reduxjs/toolkit";
import getPrice from "@custom/rtk-apis/price/getPrice";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  pagination:null,
  error:""
};

const getPriceSlice = createSlice({
  name: "getPriceSlice",
  initialState,
  reducers: {
    closeModal (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getPrice.pending, (state, action) => {
        state.loading = true;
        state.status = 'pending';
      })
      .addCase(getPrice.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.pagination = payload.pagination;
        state.msg = payload.msg;
      })
      .addCase(getPrice.rejected, (state,  action ) => {
        state.result = [];
        state.loading = false;
        state.status = 'failed';
      });
  },
});

export default getPriceSlice.reducer;
export const { closeModal } = getPriceSlice.actions;
